var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"Button",class:_vm.customClass,attrs:{"type":_vm.type,"disabled":_vm.loading || _vm.disabled}},[(_vm.loading)?_c('span',{staticClass:"Button__loader"}):_vm._e(),_c('span',{staticClass:"Button__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }